// 轻量认证与登录校验工具

export function getUserInfoSafe() {
    try {
        const raw = localStorage.getItem('userInfo');
        const obj = raw ? JSON.parse(raw) : null;
        return typeof obj === 'object' && obj !== null ? obj : null;
    } catch (e) {
        return null;
    }
}

export function getToken() {
    return localStorage.getItem('token');
}

export function isLoggedIn(userInfo = getUserInfoSafe(), token = getToken()) {
    return !!(userInfo || token);
}

export function isBuyPackage(userInfo = getUserInfoSafe()) {
    const pkgId = userInfo && Object.prototype.hasOwnProperty.call(userInfo, 'package_id') && userInfo.package_id != null ? userInfo.package_id : 0;
    return Number(pkgId) > 0;
}

// 需要在组件内调用：requireLogin(this)
export function requireLogin(ctx) {
    const userInfo = getUserInfoSafe();
    const token = getToken();
    const loggedIn = isLoggedIn(userInfo, token);
    if (!loggedIn) {
        if (ctx.$dialog && ctx.$dialog.confirm) {
            ctx.$dialog
                .confirm({
                    title: ctx.$t('my.confirmTitle'),
                    message: ctx.$t('my.pleaseLogin'),
                    confirmButtonText: ctx.$t('my.confirm'),
                    cancelButtonText: ctx.$t('my.cancel'),
                })
                .then(() => {
                    ctx.$router.push('/login');
                })
                .catch(() => { });
        } else {
            ctx.$toast && ctx.$toast(ctx.$t('my.pleaseLogin'));
            setTimeout(() => ctx.$router.push('/login'), 300);
        }
        return false;
    }
    return true;
}


